var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Table } from '@devexpress/dx-react-grid-bootstrap4';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const TableComponentBase = (_a) => {
    var restProps = __rest(_a, []);
    return (React.createElement(Table.Table, Object.assign({}, restProps, { className: "grid-table-base" })));
};
//# sourceMappingURL=TableComponentBase.js.map